
export class PpmDetails{
    poLineProp:string;
   
}